import { Skeleton } from "@mui/material";
import { memo } from "react";

export const PositionTableSkeletonRow = memo(() => (
    <tr className="border-t border-portfolio-positions-table">
        <td className="p-4">
            <Skeleton variant="text" width="50%" height={20} className="bg-portfolio-positions-table-skeleton" />
        </td>
        <td className="p-4">
            <Skeleton variant="text" width="70%" height={20} className="bg-portfolio-positions-table-skeleton" />
        </td>
        <td className="p-4">
            <Skeleton variant="text" width="60%" height={20} className="bg-portfolio-positions-table-skeleton" />
        </td>
        <td className="p-4">
            <Skeleton variant="text" width="40%" height={20} className="bg-portfolio-positions-table-skeleton" />
        </td>
        <td className="p-4">
            <Skeleton
                variant="rectangular"
                width={80}
                height={28}
                className="rounded bg-portfolio-positions-table-skeleton"
            />
        </td>
    </tr>
));

PositionTableSkeletonRow.displayName = "PositionTableSkeletonRow";
